import React from 'react';
import Cleave from 'cleave.js/react';
import styles from './styles.module.scss';

const Expiration = ({
  id,
  title,
  error,
  onChange,
  onKeyPress,
  placeholder,
}) => {
  const isError = error !== undefined;
  return (
    <div className={styles.container}>
      <p className={styles.title}>{title}</p>
      <label>
        <Cleave
          id={id}
          onChange={onChange}
          onKeyPress={onKeyPress}
          className={isError ? 'error' : ''}
          options={{ numericOnly: true }}
          minLength={2}
          maxLength={2}
          placeholder={placeholder}
          required
          readOnly
        />
      </label>
      <p className={styles.error}>{isError ? error : ''}</p>
    </div>
  );
};

export default Expiration;
